import { oz } from '@weft/utils';
import { NotificationEntitySchema } from './notification-entity-schema';

export const BaseNotificationSchema = oz.object({
  message: oz.string().optional(),
  duplicationId: oz.string().optional(),
  entity: NotificationEntitySchema,
});

export type BaseNotification = oz.infer<typeof BaseNotificationSchema>;